import React from "react";

function EventListManagement({ disabled, onEditClick, onRemoveLick, selectedEvent }) {
    if (disabled) return null;

    return (
        <div className="pt-4 mt-4 border-top space-y-3">
            <h4 className="font-weight-bold text-slate-800 mb-3 oct_syslog-h4">Manage Selected Keyword</h4>

            <button
                className="oct_btn-export-v2 w-100 d-flex justify-content-center align-items-center oct_syslog-btn-base mb-2"
                onClick={onEditClick}>
                Edit "{selectedEvent?.name}"
            </button>

            <button
                className="oct_btn-export-v2 w-100 d-flex justify-content-center align-items-center oct_syslog-btn-danger"
                onClick={onRemoveLick}>
                Remove "{selectedEvent?.name}"
            </button>
        </div>
    )
}

export default EventListManagement;
